import React, { useEffect, useState } from "react"
import { GetPatientsOfProfessionalResponsePayload } from "pokal_api"
import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import { ArrayElement } from "../../types/ArrayElement"
import { useAppDispatch, useAppSelector } from "../../redux/store/hooks"
import {
    selectDashboardPatient,
    selectPatientsOfProfessional
} from "../../redux/ProfessionalDashboard"
import { ContextMenuPosition, showContextMenu } from "../../redux/ContextMenu"
import PatientListItemMenu from "../../menu/PatientListItemMenu"
import notNull from "../../util/notNull"
import Table from "../Table"
import {
    hidePatientSelectionViewPatientList,
    increaseOnboardingStep,
    mockPatientUsed,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../../redux/Onboarding"
import mockPatient from "../../onboarding/mock/mockPatient"
import { useNavigate } from "react-router-dom"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../../navigation/NavigationController"

interface PatientListProps {
    onSelect?: () => void
}

function PatientList(props: PatientListProps) {
    const dispatch = useAppDispatch()

    const [patients, setPatients] =
        useState<GetPatientsOfProfessionalResponsePayload | null>(null)
    const fetchedPatients = useAppSelector(selectPatientsOfProfessional)
    const mockPatients = mockPatient()
    const headers: string[] = ["Vorname", "Nachname", "Geburtstag", "BMI"]

    const step = useAppSelector(selectOnboardingStep)
    const running = useAppSelector(selectOnboardingIsRunningState)

    useEffect(() => {
        if (mockPatientUsed(running, step)) {
            setPatients(mockPatients)
        } else setPatients(fetchedPatients)
    }, [running, step, fetchedPatients])

    function patientToStringArray(
        elem: ArrayElement<GetPatientsOfProfessionalResponsePayload>
    ): string[] {
        return [
            elem.firstName,
            elem.lastName,
            new Date(elem.birthdate).toLocaleDateString("de"),
            String(elem.bmi)
        ]
    }

    function openContextMenu(id: string, position: ContextMenuPosition) {
        dispatch(showContextMenu({ position, items: PatientListItemMenu() }))
    }
    const navigate = useNavigate()

    function onSelect(
        elem: ArrayElement<GetPatientsOfProfessionalResponsePayload>
    ) {
        if (mockPatientUsed(running, step)) {
            dispatch(increaseOnboardingStep())
            navigate(NavigationPaths[NAVIGATION_VIEW.PATIENT_OVERVIEW].path)
        } else {
            dispatch(selectDashboardPatient(elem))
            if (props.onSelect) {
                props.onSelect()
            }
        }
    }

    return (
        <Card
            maxHeight={600}
            width={"100%"}
            blur={hidePatientSelectionViewPatientList(running, step)}>
            <div className={"w-full flex flex-col space-y-4"}>
                <SmallHeadingComponent>
                    Patient:innen-Auswahl
                </SmallHeadingComponent>
                {notNull(patients) ? (
                    <div className={"flex flex-col"}>
                        {
                            hidePatientSelectionViewPatientList(
                                running,
                                step
                            ) || patients.length >  0 ? (
                                <Table
                                    header={headers}
                                    data={
                                        hidePatientSelectionViewPatientList(
                                            running,
                                            step
                                        )
                                            ? []
                                            : patients
                                    }
                                    rowBuilder={patientToStringArray}
                                    selectable={false}
                                    onClick={onSelect}
                                />
                            ) : (
                                <div className={"text-gray-500 font-bold"}>Aktuell keine Patient:innen verknüpft.</div>
                            )
                        }
                    </div>
                ) : (
                    <div className={"italic"}>
                        Patient:innen konnten nicht geladen werden.
                    </div>
                )}
            </div>
        </Card>
    )
}

export default PatientList
